import { Controller } from 'stimulus';

// Gate one input behind another: while the "gate" input is unchecked, the
// gated "input" is disabled (greyed out). E.g. the org "Manage Key Indicators"
// table, where a KI that isn't Available can't be on by default.
export default class extends Controller {
  static targets = ['gate', 'input'];

  connect() {
    this.sync();
  }

  sync() {
    this.inputTarget.disabled = !this.gateTarget.checked;
  }
}
